import React, {Fragment} from 'react';
import Button from "../../Button";
import TextInput from '../../TextInput';
import Modal from "../../../layout/Modal";
import Portal from "../../../layout/Portal";
import {set, get} from '../../../../utils/dotutils';
import {isEmpty} from "../../../../utils/other";
import classNames from "classnames";
import Icon from "../../Icon";
import { Tooltip } from 'react-tippy';
import {loadComponentById} from "../../../../utils/components";

class VariableNode extends React.Component {

    state = {
        data: null
    }

    constructor(props) {
        super(props);
        this.loadData();
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.component_type + "_" + this.props.component_id + "_" + this.props.children[0].props.node.get('text') !== prevProps.component_type + "_" + prevProps.component_id + "_" + prevProps.children[0].props.node.get('text')) {
            this.loadData();
        }
    }

    loadData = () => {
        if (this.props.component_type && this.props.component_id) {
            this.loadDataRequest && this.loadDataRequest.abort();
            const field = this.props.children[0].props.node.get('text');
            this.loadDataRequest = loadComponentById(this.props.component_type, this.props.component_id, [field]);
            this.loadDataRequest.then((component) => {
                this.setState({data: get(component, field)});
            })
        } else {
            this.setState({data: null});
        }
    }

    render() {
        const Tag = this.state.data ? Tooltip : "span";
        return (
            <span
                {...this.props.attributes}
                className={classNames(this.props.attributes.className, this.props.node.data.get("type"), "variable")}
            >
                <span className="variable-text">{this.props.children}</span>
                {!!this.state.data && <Tag {...(this.state.data ? {html: this.state.data, tag: "span", position: "top"} : {})}>
                    <Icon lib="fas" name="info-circle"/>
                </Tag>}
                <span className="remove" onClick={(e) => {
                    e && e.preventDefault();
                    const change = this.props.editor.removeNodeByKey(this.props.node.key);
                    this.props.saveEditing && this.props.saveEditing(change);
                }}>
                    <Icon lib="fa" name="times"/>
                </span>
            </span>
        );
    }
}

const isVariable = (value) => value.inlines.size + "" === "1" && value.inlines.find((inline) => inline.type + "" === 'variable');

export const VariableModal = (props) => {
    const {type, variable} = props.data;
    return <div className="row">
        <div className="col-md-12">
            {/*<div className="row form-row">
                <div className="col-md-12">
                    <Select name="type" objectValue={false} optionname="variabletype" storeType="local" saveChanges={props.setValue} value={type} label="Változó típusa" />
                </div>
            </div>*/}
            <div className="row form-row">
                <div className="col-md-12">
                    <TextInput name="variable" disabled={true} value={variable || ''} saveChanges={props.setValue} label="Változó" />
                </div>
            </div>
        </div>
    </div>;
};

const defaultEditData = {
    type: 'mustache', variable: ''
}

class VariableButton extends React.Component {

    state = {
        editing: false
    }

    openEditor = (e) => {
        e && e.preventDefault();
        let propsValue = null;
        if (isVariable(this.props.value)) {
            const variablenode = this.props.value.inlines.find((inline) => inline.type + "" === 'variable');
            propsValue = {...variablenode.data.toObject()};
            propsValue.variable = variablenode.nodes.get(0).text;
        } else {
            propsValue = {...defaultEditData};
            propsValue.variable = this.props.value.fragment.text;
        }
        this.setState({editing: true, value: propsValue});
        return false;
    }

    onModalChange = (field, value) => {
        const newValue = {...this.state.value};
        set(newValue, field, value);
        this.setState({value: newValue});
    }

    render() {
        const values = this.state.value || {};
        return <Fragment>
            <Button
                onClick={this.openEditor}
                icon="highlight_alt"
                color={isVariable(this.props.value) ? "primary" : "default"}
                tooltip={"Változó" + (!isVariable(this.props.value) ? " beszúrása" : " szerkesztése")}
                disabled={this.props.disabled || (!isVariable(this.props.value) && !this.props.value.selection.isExpanded)}
            />
            <Portal>
                <Modal
                    state={this.state.editing ? "on" : "off"}
                    header={"Változó" + (!isVariable(this.props.value) ? " beszúrása" : " szerkesztése")}
                    buttons={[
                        {
                            text: "Ok",
                            props: {color: "primary", disabled: isEmpty(values.variable)},
                            onClick: async () => {
                                let editor = null;
                                const data = {...this.state.value};
                                this.setState({editing:false});
                                if (!isVariable(this.props.value)) {
                                    editor = this.props.editor
                                        .wrapInline({type: 'variable', data, nodes: [{object: "text", text: data.variable, marks: []}]})
                                        .focus();
                                } else {
                                    editor = this.props.editor
                                        .setInlines({type: 'variable', data, nodes: [{object: "text", text: data.variable, marks: []}]})
                                        .focus();
                                }
                                this.props.saveEditing && this.props.saveEditing(editor);
                            }
                        }, {
                            text: "Mégse",
                            props: {color: "default"},
                            onClose: true,
                            onClick: async () => {
                                this.setState({editing:false});
                            }
                        }
                    ]}>
                    <VariableModal data={values} setValue={this.onModalChange} />
                </Modal>
            </Portal>
        </Fragment>
    }
}

export {VariableNode, VariableButton};